const ediciondecontenido = {
    GetContenidosDePaginaWeb: 'SICPO/EdicionDeContenido/GetContenidosDePaginaWeb',
    CambiarEstatusDeContenidosPaginaWeb: 'SICPO/EdicionDeContenido/CambiarEstatusDeContenidos',
    EditarContenidoPaginaWeb: 'SICPO/EdicionDeContenido/EditarContenidoPaginaWeb',
    CambiarEstatusArchivoDeContenidoPw: 'SICPO/EdicionDeContenido/CambiarEstatusArchivoDeContenidoPaginaWeb',
    OrdenamientoAlfabeticoDeContenidos: 'SICPO/EdicionDeContenido/OrdenamientoAlfabeticoDeContenidos'
}

export default ediciondecontenido;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICPO/sistema/paginaweb/ediciondecontenido/ediciondecontenido.js
// module id = null
// module chunks = 